<template>
    <select v-model="$i18n.locale" class="locale-select" @change="onChange($event)">
        <option v-for="(lang, i) in langs" :key="`lang-${i}`" :value="lang">
            {{ lang }}
        </option>
    </select>
</template>

<script>
    import UsersAPI from 'api/UsersAPI'
    import AuthService from 'services/AuthService'
    import LanguageEnum from 'enums/language.enum'

    export default {
        data: () => ({
            langs: Object.values(LanguageEnum),
        }),
        methods: {
            onChange(event) {
                if (AuthService.isLoggedIn()) {
                    UsersAPI.updateLanguage({ language: event.target.value })
                }
                localStorage.setItem('locale', event.target.value)
            },
        },
    }
</script>

<style lang="scss" scoped>
    @import 'styles/setup/variables';
    @import 'styles/setup/_mixins.scss';

    .locale-select {
        width: 45px;
        height: 22px;
        margin-right: 20px;
        text-transform: uppercase;
        color: $color--txt-header-1;
        border-radius: 10px;
        cursor: pointer;
        transition: border-color 0.2s ease-in-out;

        @include breakpoint(smartphone) {
            margin-right: 10px;
        }
    }

    .subdomain-layout--navy_black,
    .subdomain-layout--black {
        .locale-select {
            background-color: $subdomain-midnight;
            color: $color-white;
            border: 1px solid $color-white;
            border-radius: 15px;
            height: 28px;
            padding-left: 2px;
        }
    }
</style>
